import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import './i18n'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://ebb7d548288c4bedb037343850de6f22@o14401.ingest.sentry.io/4504871608451072',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
    environment: process.env.REACT_APP_ENV,
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
